import { Controller } from "react-hook-form";
import { FormInputProps } from "../types";
import { Autocomplete, TextField, Chip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

interface IProps {
  selectOptions: { label: string; value: any }[];
  defaultValue?: any;
  loading?: boolean;
  variant?: "filled" | "standard";
  freeSolo?: boolean;
  onInputChange?: any;
  inputValue?: string;
  noOptionsText?: string;
  disableRemoveFor?: string[];
}

type TypeMergedInterfaces = FormInputProps & IProps;

export function FormMultipleAutoComplete({
  name,
  control,
  label,
  required,
  selectOptions,
  defaultValue,
  freeSolo,
  loading,
  onInputChange,
  inputValue,
  noOptionsText,
  variant,
  disableRemoveFor = [],
}: TypeMergedInterfaces) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{
        required: required,
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Autocomplete
            sx={{
              "& .MuiFilledInput-root": { backgroundColor: "neutral100.main" },
            }}
            freeSolo={freeSolo}
            loading={loading}
            multiple
            autoHighlight={false}
            noOptionsText={noOptionsText}
            options={selectOptions}
            // Busca remota: não filtrar localmente — opções já vêm filtradas do servidor
            filterOptions={(options) => options}
            value={value || []}
            inputValue={inputValue}
            onInputChange={onInputChange || false}
            onChange={(_, newValue) => {
              onChange([...newValue]);
            }}
            getOptionLabel={(option) => option.label || ""}
            disableCloseOnSelect
            fullWidth
            isOptionEqualToValue={(option, value) =>
              option?.value === value.value
            }
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={index}
                  label={option.label}
                  deleteIcon={
                    disableRemoveFor.includes(option.value) ? <></> : undefined
                  }
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant={variant || "outlined"}
                label={label}
                error={error !== undefined}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        );
      }}
    />
  );
}
